import Big from 'big.js'
import { ProductCoverInformation } from 'components'
import { InvestComponent } from 'components/widgets/invest-component'
import type { ProductMetadata } from 'indices-list'
import type React from 'react'
import { useEffect, useState } from 'react'
import { isAddressEqual } from 'viem'
import { getProductCoverInformation } from '../../components/index-cover/services'
import { ProductMetaTags } from './component/meta-tags'
import { ContentSwitch } from './component/switch-sections/index'
import { TotalExposure } from './component/total-exposure'
import ProductLoading from './loading'
import { createProductStorage } from './storage'
import { ContentWrapper, MainContentWrapper, ProductOverview } from './styled'

export const ProductPage: React.FC<{ product: ProductMetadata }> = ({ product }): JSX.Element => {
  const storage = createProductStorage(product.productType)
  const coverInformation = getProductCoverInformation(
    storage.product,
    storage.dailyStats,
    storage.apy,
  )
  const [isLoading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(
      (!isAddressEqual(storage.product.address, product.address) && !storage.isError) ||
        Big(coverInformation[1].value.substring(1)).eq(1),
    )
  }, [storage])

  return isLoading ? (
    <ProductLoading product={product} />
  ) : (
    <>
      <ProductMetaTags address={product.address} />
      <ProductOverview>
        <ProductCoverInformation
          coverInformation={coverInformation}
          productMetaData={product}
          tagLine={product.tagLine}
        />
        <InvestComponent productMetadata={product} />
      </ProductOverview>
      <MainContentWrapper>
        <ContentWrapper>
          <ContentSwitch store={storage} productMetadata={product} />
          <TotalExposure product={product} />
        </ContentWrapper>
      </MainContentWrapper>
    </>
  )
}
